import React from 'react';
import { NavLink } from 'react-router-dom';
import { StyledNavTab, StyledNavTabContainer } from '@bit/knotchinc.web-react-components.tabs';

const PageHeaderTabs = ({ tabs }) => {
  const headerTabs = tabs.map(({ text, link, active }, i) =>
    <StyledNavTab as={NavLink} key={i} to={link} activeClassName="active" active={active}>
      {text}
    </StyledNavTab>);

  return (<StyledNavTabContainer>{headerTabs}</StyledNavTabContainer>);
};

export default PageHeaderTabs;
